import { isEqualWith } from 'lodash'

export type ModelTreeState = {
  hiddenNodeIds: string[]
  ghostedNodeIds: string[]
  lockedNodeIds: string[]
}

export type PartLocation = {
  rotation: { x: number, y: number, z: number, w: number }
  scale: { x: number, y: number, z: number }
  translation: { x: number, y: number, z: number }
}

export type AdminViewerState = {
  camera: Record<string, unknown> | null
  partLocations: Record<string, PartLocation>
}

export type AdminSnapshotState = AdminViewerState & { tree: ModelTreeState }

export function emptyModelTreeState (): ModelTreeState {
  return { hiddenNodeIds: [], ghostedNodeIds: [], lockedNodeIds: [] }
}

export function samePersistedValue (left: unknown, right: unknown): boolean {
  return isEqualWith(left, right, (a, b) => {
    if (typeof a === 'number' && typeof b === 'number') {
      return Math.abs(a - b) <= 1e-6
    }
    return undefined
  })
}

export function sameSnapshotState (left: AdminSnapshotState, right: AdminSnapshotState): boolean {
  const normalize = (state: AdminSnapshotState) => ({
    ...state,
    tree: Object.fromEntries(Object.entries(state.tree).map(([key, ids]) => [key, [...ids].sort()]))
  })
  return samePersistedValue(normalize(left), normalize(right))
}
